import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '../../../project/reusableComponents/AccordianForTeams';
import { RenderHeader } from '.';
import EditTags from '../EditTags';


export const RenderTags = ({ user, expanded, handleChange }) => {
    return <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')} elevation={0}>
        <AccordionSummary expandIcon={<span className='material-icons text-scogobgsky'> expand_more </span>} aria-controls='panel3bh-content' id='panel3bh-header'>
            <RenderHeader title='Update/Verify Tags Detail' isVerfied={user.is_verified} />
        </AccordionSummary>
        <AccordionDetails>
            <div className='px-6'>
                <EditTags userId={user.id} />
            </div>
        </AccordionDetails>
    </Accordion>
}